// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import clsx from 'clsx';
import { InternalButton } from '../../../button/internal';
import { getBaseProps } from '../../base-component';
import { GroupedControlContext, } from '../../context/control-group-context';
import { fireNonCancelableEvent } from '../../events';
import { flattenChildren } from '../../utils/flatten-children';
import styles from './styles.css.js';
export default function InternalControlGroup({ children, direction = 'horizontal', actionButton, ...props }) {
    const baseProps = getBaseProps(props);
    const flattenedChildren = flattenChildren(children, 'ControlGroup');
    const controlCount = flattenedChildren.length;
    const controls = (React.createElement("div", { ...(actionButton ? {} : baseProps), role: "group", className: clsx(actionButton ? undefined : baseProps.className, styles.root, styles[`root-${direction}`]) }, flattenedChildren.map((child, index) => {
        const key = child && typeof child === 'object' ? child.key : undefined;
        const position = controlCount === 1 ? 'only' : index === 0 ? 'first' : index === controlCount - 1 ? 'last' : 'middle';
        return (React.createElement("div", { key: key ? String(key) : index, className: clsx(styles.control, styles[`control-${position}-${direction}`]) },
            React.createElement(GroupedControlContext.Provider, { value: { position, direction, endAction: !!actionButton } }, child)));
    })));
    if (!actionButton) {
        return controls;
    }
    return (React.createElement("div", { ...baseProps, className: clsx(baseProps.className, styles.layout, styles[`layout-${direction}`]) },
        controls,
        React.createElement("div", { className: styles['action-slot'] },
            React.createElement(GroupedControlContext.Provider, { value: { position: 'last', direction: 'horizontal' } },
                React.createElement(InternalButton, { variant: "icon", iconName: actionButton.iconName, iconAlt: actionButton.iconAlt, ariaLabel: actionButton.ariaLabel, disabled: actionButton.disabled, disabledReason: actionButton.disabledReason, ariaDescribedby: actionButton.ariaDescribedby, onClick: () => fireNonCancelableEvent(actionButton.onClick) })))));
}
//# sourceMappingURL=index.js.map